import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AuctionTemplateRow from './AuctionTemplateRow';
import {
    auctionTemplatePropertiesType,
    auctionTemplatesType,
    sortingParamType,
} from '../../types';
import './_styles_/AuctionTemplatesList.css';
import SortControl from '../SortControl';

AuctionTemplatesList.propTypes = {
    auctionTemplates: auctionTemplatesType.isRequired,
    auctionTemplateProps: auctionTemplatePropertiesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function AuctionTemplatesList(props) {
    const {
        auctionTemplates,
        auctionTemplateProps,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="auction-templates-list">
            <div className="rich-list-row rich-list-header auction-templates-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="auction-template-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('auction-templates.list-header.name')}
                    </SortControl>
                </div>
                <div className="auction-template-header--values--product">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="product.productId">
                        {t('auction-templates.list-header.product')}
                    </SortControl>
                </div>
                <div className="auction-template-header--values--description">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="description">
                        {t('auction-templates.list-header.description')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                auctionTemplates.length
                    ? auctionTemplates.map((auctionTemplate) => (
                        <AuctionTemplateRow
                            auctionTemplate={auctionTemplate}
                            auctionTemplateProps={auctionTemplateProps}
                            key={auctionTemplate.id}
                        />
                    ))
                    : (<div className="auction-templates-no-items">{t('auction-templates.no-items')}</div>)
            }
        </div>
    );
}

export default AuctionTemplatesList;
